/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AppTitle.vue?vue&type=template&id=cf8355a4"
import script from "./AppTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppTitle.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppTitle.vue?vue&type=style&index=0&id=cf8355a4&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports